export const clear = {
  outline: 'none',
  background: 'none',
  cursor: 'pointer',
  border: 0,
};
